import { createStyles } from '@material-ui/core/styles';

export const styles = () => {
  return createStyles({
    root: {},
  });
};
